const useStyles = () => {
    return {
        container: {
            padding: '16px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            '& .font-bold': {
                fontWeight: 'bold'
            }
        },
        version: {
            display: 'flex',
            flexDirection: 'column',
        }
    }
}

export { useStyles }
